import { getIsIntegrationChannelsMetadataSupported } from '@modules/integrationsV2/utils';
import { IntegrationChannelType } from 'generated/graphql';

export const getCanAddIntegrationChannelsMetadata = (
  channelType: IntegrationChannelType,
) => {
  switch (channelType) {
    case IntegrationChannelType.Discourse:
      return false;
    default:
      return getIsIntegrationChannelsMetadataSupported(channelType);
  }
};
